import {
  ArrowRight,
  MapPin,
  Users,
  Star,
  Globe,
  ArrowDown,
} from "lucide-react";
import { isMobile } from "react-device-detect";

const GroupLeaderInfo = () => {
  const pastLeaders = [
    {
      name: "Markus",
      image:
        "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/236703hike-trip-lead.jpg",
      location: "Ijen & Bromo",
      quote:
        "The most memorable moment was when everyone made it to the summit together - the way the group encouraged and supported each other throughout the climb made it unforgettable.",
    },
    {
      name: "Larry",
      location: "French Alps",
      quote:
        "Leading trips is incredibly rewarding - it adds a whole new dimension of fun and makes each adventure uniquely special",
      image:
        "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/277039larry-lead-trip.jpg",
    },
    {
      name: "Shawn",
      location: "Whaleshark Cebu",
      quote:
        "Dived into the ocean with whale sharks, and now I'm diving into the exciting world of leading trips and creating lifelong memories!",
      image:
        "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/161077trip-lead-dive.jpg",
    },
  ];

  return (
    <div className="tw-min-h-screen tw-font-sans">
      {/* Hero Section with Parallax Effect */}
      <section className="tw-relative tw-h-[70vh] tw-overflow-hidden">
        <div
          className="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-transform tw-scale-110"
          style={{
            backgroundImage:
              "url('https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/151028Copy%20of%20IMG_4012.JPG')",
            transform: "translateZ(-1px) scale(1)",
          }}
        />
        <div className="tw-absolute tw-inset-0 tw-bg-black/40" />
        <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
          <div className="tw-text-center tw-text-white tw-max-w-4xl tw-px-4">
            <h1 className="tw-text-[34px] md:tw-text-[52px] tw-font-bold tw-mb-3 tw-leading-tight">
              Lead adventures,
              <br />
              create stories
            </h1>
            <p className="tw-text-[18px] md:tw-text-[20px] tw-mb-5 tw-text-gray-200 tw-max-w-2xl tw-mx-auto">
              Join our community of passionate trip leaders and shape
              unforgettable experiences
            </p>
            <button
              onClick={() =>
                alert(
                  "Reach out to @sotravel_official on telegram to indicate your interest to be a group leader!"
                )
              }
              className="tw-bg-[#00BFFF] tw-text-white tw-font-medium tw-py-2.5 tw-px-6 tw-rounded-full tw-text-[16px] hover:tw-bg-[#00A3D9] tw-transition tw-duration-300"
            >
              Start your journey
            </button>
          </div>
        </div>
      </section>

      {/* Who is this for Section */}
      <section className="tw-py-12 tw-bg-white">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-text-[26px] tw-font-bold tw-text-center tw-mb-8">
            Who are we looking for?
          </h2>
          <div className="tw-grid md:tw-grid-cols-2 tw-gap-4 tw-max-w-4xl tw-mx-auto">
            <div className="tw-bg-white tw-rounded-lg tw-p-5 tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-w-10 tw-h-10 tw-bg-[#00BFFF] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                  <Star className="tw-text-white tw-w-5 tw-h-5" />
                </div>
                <div>
                  <h3 className="tw-text-[20px] tw-font-medium tw-mb-1.5">
                    Contagious energy
                  </h3>
                  <p className="tw-text-[16px] tw-text-gray-600">
                    Being around you feels like the best part of the trip. You
                    know when to push for excitement and when to pull back for
                    rest. If you’re the kind of person who builds connections
                    naturally, this is your opportunity to lead trips that leave
                    lifelong impressions.
                  </p>
                </div>
              </div>
            </div>
            <div className="tw-bg-white tw-rounded-lg tw-p-5 tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-start tw-space-x-4">
                <div className="tw-w-10 tw-h-10 tw-bg-[#00BFFF] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                  <Users className="tw-text-white tw-w-5 tw-h-5" />
                </div>
                <div>
                  <h3 className="tw-text-[20px] tw-font-medium tw-mb-1.5">
                    Relatable and dependable
                  </h3>
                  <p className="tw-text-[16px] tw-text-gray-600">
                    You’re the one who brings warmth and comfort, making sure no
                    one feels left out. It’s not about planning every
                    detail—it’s about being responsible and genuinely caring for
                    others. Whether it’s lifting spirits or helping out when
                    it’s needed most, you’re the glue that keeps the group
                    connected and thriving.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section
        className="tw-py-12 tw-bg-cover tw-bg-center tw-relative"
        style={{
          backgroundImage:
            "url('https://www.nepalsanctuarytreks.com/wp-content/uploads/2019/12/DSC_0474.jpg.webp')",
        }}
      >
        <div className="tw-absolute inset-0 tw-bg-black/50"></div>
        <div className="tw-container tw-mx-auto tw-px-4 tw-relative">
          <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-6">
            <div className="tw-bg-white/90 tw-backdrop-blur-sm tw-rounded-lg tw-px-8 tw-py-4 tw-shadow-sm tw-w-[200px]">
              <div className="tw-text-[26px] tw-font-bold tw-text-[#00BFFF]">
                50+
              </div>
              <div className="tw-text-[16px] tw-text-gray-600">
                Active trip Leaders
              </div>
            </div>
            <div className="tw-bg-white/90 tw-backdrop-blur-sm tw-rounded-lg tw-px-8 tw-py-4 tw-shadow-sm tw-w-[200px]">
              <div className="tw-text-[26px] tw-font-bold tw-text-[#00BFFF]">
                200+
              </div>
              <div className="tw-text-[16px] tw-text-gray-600">
                Trips completed
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What Trip Leaders Do Section */}
      <section className="tw-py-12 tw-bg-white">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-text-[26px] tw-font-bold tw-text-center tw-mb-8">
            What group leaders do
          </h2>
          <div className="tw-grid md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-max-w-4xl tw-mx-auto">
            <div className="tw-bg-white tw-p-5 tw-rounded-lg tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-center tw-gap-3 tw-mb-2">
                <div className="tw-w-10 tw-h-10 tw-bg-[#00BFFF]/10 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                  <Users className="tw-text-[#00BFFF] tw-w-5 tw-h-5" />
                </div>
                <h3 className="tw-text-[20px] tw-font-medium">
                  Simple admin tasks
                </h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Set meeting points and communicate the group needs with our
                guides
              </p>
            </div>
            <div className="tw-bg-white tw-p-5 tw-rounded-lg tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-center tw-gap-3 tw-mb-2">
                <div className="tw-w-10 tw-h-10 tw-bg-[#00BFFF]/10 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                  <Star className="tw-text-[#00BFFF] tw-w-5 tw-h-5" />
                </div>
                <h3 className="tw-text-[20px] tw-font-medium">
                  Bring the vibe
                </h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Create a fun, easy-going, and open atmosphere for the group
              </p>
            </div>
            <div className="tw-bg-white tw-p-5 tw-rounded-lg tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-duration-300">
              <div className="tw-flex tw-items-center tw-gap-3 tw-mb-2">
                <div className="tw-w-10 tw-h-10 tw-bg-[#00BFFF]/10 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                  <Globe className="tw-text-[#00BFFF] tw-w-5 tw-h-5" />
                </div>
                <h3 className="tw-text-[20px] tw-font-medium">
                  Handle simple issues
                </h3>
              </div>
              <p className="tw-text-[16px] tw-text-gray-600">
                Help to resolve simple issues with our guides and surface it to
                us if required.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Journey Timeline - With Arrows */}
      <section className="tw-py-10 tw-bg-gradient-to-b tw-from-gray-50 tw-to-gray-100 tw-relative">
        <div className="tw-absolute tw-inset-0 tw-opacity-10">
          <img
            src="/patterns/world-map.svg"
            alt=""
            className="tw-w-full tw-h-full tw-object-cover"
          />
        </div>
        <div className="tw-container tw-mx-auto tw-px-4 tw-relative">
          <h2 className="tw-text-[26px] md:tw-text-[34px] tw-font-bold tw-text-center tw-mb-6">
            Group leader journey
          </h2>
          <div className="tw-relative tw-max-w-4xl tw-mx-auto">
            <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-h-full tw-w-1 tw-bg-[#00BFFF] tw-z-10">
              <div className="tw-absolute -tw-top-2 tw-left-1/2 -tw-translate-x-1/2 tw-w-4 tw-h-4 tw-rounded-full tw-bg-[#00BFFF]"></div>
              <div className="tw-absolute -tw-bottom-2 tw-left-1/2 -tw-translate-x-1/2 tw-w-4 tw-h-4 tw-rounded-full tw-bg-[#00BFFF]"></div>
            </div>
            <div className="tw-space-y-4 md:tw-space-y-8">
              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                {!isMobile && (
                  <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-z-10">
                    <ArrowDown className="tw-w-8 tw-h-8 tw-text-[#00BFFF] tw-font-bold" />
                  </div>
                )}
                <div className="tw-pl-[calc(3%+2rem)] md:tw-pl-[calc(25%+2rem)] md:tw-w-[700px]">
                  <div className="tw-bg-white/90 tw-backdrop-blur tw-p-6 tw-rounded-xl tw-shadow-md">
                    <h3 className="tw-text-[22px] tw-font-semibold tw-text-[#00BFFF] tw-mb-2">
                      Group leader 👼
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600 tw-font-bold">
                      Get 25% off first trip, 50% off second
                    </p>
                    <ul className="tw-list-disc tw-list-inside tw-text-[16px] tw-text-gray-600 tw-mt-4">
                      <li>Handle simple admin tasks</li>
                      <li>Build confidence</li>
                      <li>Feel the vibe</li>
                    </ul>
                  </div>
                </div>
              </div>

              <p className="tw-text-center tw-text-gray-600 tw-italic">
                After successfully leading two trips
              </p>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-z-10">
                  <ArrowDown className="tw-w-8 tw-h-8 tw-text-[#00BFFF] tw-font-bold" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-pl-[calc(25%+2rem)] md:tw-w-[700px]">
                  <div className="tw-bg-white/90 tw-backdrop-blur tw-p-6 tw-rounded-xl tw-shadow-md">
                    <h3 className="tw-text-[22px] tw-font-semibold tw-text-[#00BFFF] tw-mb-2">
                      Invite-only: Leader bootcamp 🏔
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600 tw-font-bold">
                      Level up your skills in our 1-day in-person bootcamp where
                      you will learn to:
                    </p>
                    <ul className="tw-list-disc tw-list-inside tw-text-[16px] tw-text-gray-600 tw-mt-4">
                      <li>Master safety & trip organization</li>
                      <li>
                        Engineer connections & create inviting social circles
                      </li>
                      <li>Capture precious memories through photos & videos</li>
                      <li>Represent our brand & manage trip challenges</li>
                    </ul>
                  </div>
                </div>
              </div>

              <p className="tw-text-center tw-text-gray-600 tw-italic">
                Get promoted to super leader
              </p>

              <div className="tw-relative tw-flex tw-flex-col md:tw-flex-row md:tw-items-center">
                <div className="tw-absolute tw-left-[3%] md:tw-left-[25%] tw-transform -tw-translate-x-1/2 tw-z-10">
                  <ArrowDown className="tw-w-8 tw-h-8 tw-text-[#00BFFF] tw-font-bold" />
                </div>
                <div className="tw-pl-[calc(3%+2rem)] md:tw-pl-[calc(25%+2rem)] md:tw-w-[700px]">
                  <div className="tw-bg-white/90 tw-backdrop-blur tw-p-6 tw-rounded-xl tw-shadow-md">
                    <h3 className="tw-text-[22px] tw-font-semibold tw-text-[#00BFFF] tw-mb-2">
                      Super leader 🏆
                    </h3>
                    <p className="tw-text-[16px] tw-text-gray-600 tw-font-bold">
                      Lead trips for free and mentor new leaders
                    </p>
                    <ul className="tw-list-disc tw-list-inside tw-text-[16px] tw-text-gray-600 tw-mt-4">
                      <li>Free trips as leader</li>
                      <li>Priority access to new trips</li>
                      <li>Shape the community</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Meet Our Leaders */}
      <section className="tw-py-12 tw-bg-white">
        <div className="tw-container tw-mx-auto tw-px-4">
          <h2 className="tw-text-[26px] tw-font-bold tw-text-center tw-mb-8">
            Meet our group leaders
          </h2>
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
            {pastLeaders.map((leader, index) => (
              <div
                key={index}
                className="tw-group tw-relative tw-overflow-hidden tw-rounded-lg tw-h-[440px]"
              >
                <img
                  src={leader.image || "/placeholder.svg"}
                  alt={leader.name}
                  className="tw-w-full tw-h-full tw-object-cover tw-transition tw-duration-300 group-hover:tw-scale-105"
                />
                <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-t tw-from-black/80 tw-via-black/50 tw-to-transparent tw-flex tw-flex-col tw-justify-end tw-p-4">
                  <h3 className="tw-text-[20px] tw-font-medium tw-text-white tw-mb-1">
                    {leader.name}
                  </h3>
                  <p className="tw-text-[16px] tw-text-gray-200">
                    {leader.quote}
                  </p>
                  {leader.location && (
                    <div className="tw-flex tw-items-center tw-mt-2 tw-text-gray-300">
                      <MapPin className="tw-w-4 tw-h-4 tw-mr-1" />
                      <span className="tw-text-[14px]">{leader.location}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="tw-py-12 tw-bg-[#00BFFF]">
        <div className="tw-container tw-mx-auto tw-px-4 tw-text-center">
          <h2 className="tw-text-[26px] tw-font-bold tw-text-white tw-mb-3">
            Ready to lead amazing adventures?
          </h2>
          <p className="tw-text-[18px] tw-text-white/90 tw-mb-5 tw-max-w-2xl tw-mx-auto">
            Join our community of passionate trip leaders and start creating
            unforgettable experiences
          </p>
          <button
            onClick={() =>
              alert(
                "Reach out to @sotravel_official on telegram to indicate your interest to be a group leader!"
              )
            }
            className="tw-bg-white tw-text-[#00BFFF] tw-font-medium tw-py-2.5 tw-px-6 tw-rounded-full tw-text-[16px] hover:tw-bg-gray-50 tw-transition tw-duration-300 tw-flex tw-items-center tw-mx-auto"
          >
            Apply now
            <ArrowRight className="tw-ml-2 tw-w-4 tw-h-4" />
          </button>
        </div>
      </section>
    </div>
  );
};

export default GroupLeaderInfo;
